{
  "areYouSureToDelete": "Вы уверены что хотите удалить это сообщение? Удаление нельзя будет отменить.",
  "ask": "Задать вопрос",
  "cancel": "Отменить",
  "close": "Закрыть",
  "delete": "Удалить",
  "deleted": "Сообщение удалено",
  "edit": "Редактировать",
  "edited": "(изменено)",
  "empty": "Здесь пока никто не писал.<br />Будь первым!",
  "errorMessage": "Произошла ошибка. Пожалуйста, попробуйте позже.",
  "errorMessageTooLong": "Сообщение слишком длинное. Пожалуйста, сократите его. Лишних символов: {{ count }}.",
  "hide": "Скрыть",
  "history": "История изменений",
  "isHidden": "Скрыт",
  "loadingThreads": "Загружаем сообщения...",
  "onlyHighlightedButton": "Показать все",
  "onlyHighlightedDescription": "Отображается только выбранный тред. В этом обсуждении есть еще {threadCount, plural, one {# тред} few {# треда} many {# тредов} other {# тредов}}",
  "pin": "Закрепить",
  "pinned": "Закрепленный вопрос",
  "reply": "Ответить",
  "replyCount": "{count, plural, one {# комментарий} few {# комментария} many {# комментариев} other {# комментариев}}",
  "save": "Сохранить",
  "show": "Сделать видимым",
  "showAllAnswerText": "Посмотреть ответ полностью",
  "showAllQuestionText": "Посмотреть вопрос полностью",
  "showAnswerPreview": "Скрыть полный ответ",
  "showQuestionPreview": "Скрыть полный текст",
  "submit": "Отправить",
  "unpin": "Открепить"
}
